/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/NotificationLogsPageUiQuery$parameters.ts';
import type { NotificationLogsPageUiQuery } from './__generated__/NotificationLogsPageUiQuery.graphql.ts';

type AccountId = string;

type Queries = { notificationLogs: NotificationLogsPageUiQuery };
type ExtraProps = {
	accountId: AccountId | null;
	projectKey?: string | null;
};

type NotificationsIssueLogsEntryPointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

export const notificationsIssueLogsEntryPoint: EntryPoint<
	NotificationsIssueLogsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<NotificationsIssueLogsEntryPointComponent>(
		/* webpackChunkName: "async-software-notifications-issue-logs" */ './NotificationLogs.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			notificationLogs: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectId: Number(context?.query?.projectId ?? 0),
					notificationType: 'INTERNAL_NOTIFICATION_ISSUE',
				},
			},
		},
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
			cloudId: tenantContext.cloudId,
			projectIds: context?.query?.projectId,
			projectKey: context?.match.params.projectKey,
		},
	}),
});
